
import gql from 'graphql-tag';

const ADD_LEAD_NOTE = gql` 
  mutation addLeadNote($input: LeadNoteInput!) {
    addLeadNote(input: $input) {
      message
      code
      data
    }
  }
`;

export default ADD_LEAD_NOTE;